/** @format */

import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import ReactPaginate from "react-paginate";
import { MdEdit } from "react-icons/md";
import localOriginCharges from "../../../Services/localOriginCharges";
import locationServices from "../../../Services/locationServices";
import { ChangeStatus } from "../../../Components";
import Loader from "../../../Components/Loader";

export const CourierOriginChargeList = () => {
  const [originCourierChargeList, setOriginCourierChargeList] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loader, setLoader] = useState(true);
  // const [countryList, setCountryList] = useState([]);
  const history = useHistory();

  useEffect(() => {
    getOriginCourierChargeList();
    getCountryList();
  }, [currentPage]);

  const getOriginCourierChargeList = () => {
    // let param = { ...pagination, page: currentPage };
    localOriginCharges.getLocalOriginChargeCourier().then((res) => {
      if (res.status) {
        setLoader(false);
        setOriginCourierChargeList(res.data);
        setPagination(res.pagination);
      } else {
        setLoader(false);
      }
    });
  };

  const getCountryList = () => {
    locationServices.getCountry().then((res) => {
      if (res.status) {
        // setCountryList(res.data);
      }
    });
  };

  const onModalSubmit = () => {
    let postData = {
      _id: isModalOpen._id,
      local_origin_charge_status:
        isModalOpen.local_origin_charge_status === "ACTIVE"
          ? "INACTIVE"
          : "ACTIVE",
    };
    localOriginCharges.updateLocalOriginChargeCourier(postData).then((res) => {
      if (res.status) {
        setIsModalOpen(false);
        getOriginCourierChargeList();
      }
    });
  };

  const onPageChangeEvent = (e) => {
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };

  //   console.log("originCourierChargeList===>", originCourierChargeList);

  return (
    <div className="row justify-content-center">
      <div className="col-lg-6">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-3">
              <div>
                {/* <input
                  type="text"
                  className={"form-control"}
                  placeholder="Search..."
                /> */}
              </div>
              <button
                className="btn btn-primary w-sm waves-effect waves-light"
                onClick={() => history.push("/add-courier-origin-charge")}
              >
                Add Origin Courier Charge
              </button>
            </div>

            {originCourierChargeList.length > 0 &&
              originCourierChargeList.map((item, key) => (
                <>
                  <div className="row mb-3" key={key}>
                    <div className="col-4 courierColor">S no.</div>
                    <div className="col-8 courierBorder">
                      {/* {(pagination.page - 1) * pagination.limit + (key + 1)} */}
                      {key + 1}
                    </div>

                    <div className="col-4 courierColor">Country</div>
                    <div className="col-8 courierBorder">
                      {item.country.country_name}
                    </div>

                    <div className="col-4 courierColor">Admin Fee</div>
                    <div className="col-8 courierBorder">
                      {item.admin_fee}
                    </div>

                    <div className="col-4 courierColor">Handling In/Out</div>
                    <div className="col-8 courierBorder">
                      {item.handling_in_out}
                    </div>

                    <div className="col-4 courierColor">
                      Min Handling In/Out
                    </div>
                    <div className="col-8 courierBorder">
                      {item.min_handling_in_out}
                    </div>
                  </div>

                  <div className="table_responsive">
                    <table className="table table-centered table-nowrap mb-0 table-striped">
                      <thead className="table-light">
                        <tr>
                          <th colspan="2" className="splitting_tr_up">
                            value based charges (AED)
                          </th>
                          <th rowSpan="2" className="splitting_tr_up">
                            Price
                          </th>
                          <th rowSpan="2" className="splitting_tr_up">
                            GCC Country
                          </th>
                        </tr>
                        <tr>
                          <th className="splitting_tr_up">Start</th>
                          <th className="splitting_tr_up">End</th>
                        </tr>
                      </thead>

                      <tbody>
                        {originCourierChargeList.length > 0 &&
                          originCourierChargeList.map((item, key) => {
                            return item.origin_price.map((val, ind) => {
                              return (
                                <tr>
                                  <td className="text-center">
                                    <span>{val.min}</span>
                                  </td>
                                  <td className="text-center">
                                    <span>{val.max}</span>
                                  </td>
                                  <td className="text-center">
                                    <span>{val.price}</span>
                                  </td>

                                  <td className="text-center">
                                    {val.country.length && val.country[0].price}
                                  </td>
                                </tr>
                              );
                            });
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="row mt-3" key={key}>
                    <div className="col-4 courierColor">Status</div>
                    <div className="col-8 courierBorder">
                      <span
                        className={
                          "badge rounded-pill font-size-12 pointer" +
                          (item.local_origin_charge_status === "ACTIVE"
                            ? " bg-success"
                            : " bg-soft-danger")
                        }
                        onClick={() => setIsModalOpen(item)}
                      >
                        {item.local_origin_charge_status}
                      </span>
                    </div>

                    <div className="col-4 courierColor">Action</div>
                    <div className="col-8 courierBorder">
                      <MdEdit
                        className="pointer"
                        onClick={() =>
                          history.push(
                            "/edit-courier-origin-charge?id=" + item._id,
                            item
                          )
                        }
                        color="#0323fe"
                        size="25px"
                      />
                    </div>
                  </div>
                </>
              ))}

            {/* <div className="customTbl_lt">
              <div className="thead_left">
                <div>S no.</div>
                <div>Country</div>
                <div>Handling In/Out</div>
                <div>Min Handling In/Out</div>
                <div>Min</div>
                <div>Max</div>
                <div>Price</div>
                <div>Country</div>
                <div>Price</div>
                <div>Status</div>
                <div>Action</div>
              </div>
              <div className="tbody_left">
                {originCourierChargeList.length > 0 &&
                  originCourierChargeList.map((item, key) => (
                    <div className="tr" key={key}>
                      <div className="text-body fw-bold">
                        {(pagination.page - 1) * pagination.limit + (key + 1)}
                      </div>
                      <div>{item.country.country_name}</div>
                      <div>{item.handling_in_out}</div>
                      <div>{item.min_handling_in_out}</div>
                      <div>
                        {item.origin_price.map((val) => {
                          return <span>{val.min}</span>;
                        })}
                      </div>
                      <div>
                        {item.origin_price.map((val) => {
                          return <span>{val.max}</span>;
                        })}
                      </div>
                      <div>
                        {item.origin_price.map((val) => {
                          return <span>{val.price}</span>;
                        })}
                      </div>

                      <div>
                        {countryList &&
                          countryList.map((data, idx) => {
                            return item.origin_price.map((val) => {
                              return val.country.map((list) => {
                                if (data._id === list.country_id) {
                                  return <span>{data.country_name}</span>;
                                }
                              });
                            });
                          })}
                      </div>
                      <div>
                        {item.origin_price.map((val) => {
                          return val.country.map((list) => {
                            return <span>{list.price}</span>;
                          });
                        })}
                      </div>

                      <div>
                        <span
                          className={
                            "badge rounded-pill font-size-12 pointer" +
                            (item.local_origin_charge_status === "ACTIVE"
                              ? " bg-success"
                              : " bg-soft-danger")
                          }
                          onClick={() => setIsModalOpen(item)}
                        >
                          {item.local_origin_charge_status}
                        </span>
                      </div>

                      <div>
                        <MdEdit
                          className="pointer"
                          onClick={() =>
                            history.push(
                              "/edit-courier-origin-charge?id=" + item._id,
                              item
                            )
                          }
                          color="#0323fe"
                          size="25px"
                        />
                      </div>
                    </div>
                  ))}
              </div>
            </div> */}

            {/* <div className="table-responsive">
              <table className="table table-centered table-nowrap mb-0 table-striped">
                <thead className="table-light">
                  <tr>
                    <th>S no.</th>
                    <th>Country</th>
                    <th>Handling In/Out</th>
                    <th>Min Handling In/Out</th>
                    <th>Min</th>
                    <th>Max</th>
                    <th>Price</th>
                    <th>Country</th>
                    <th>Price</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {originCourierChargeList.length > 0 &&
                    originCourierChargeList.map((item, key) => {
                      return (
                        <tr key={key}>
                          <td>{(pagination.page - 1) * pagination.limit + (key + 1)}</td>
                          <td>{item.country.country_name}</td>
                      <td>{item.handling_in_out}</td>
                      <td>{item.min_handling_in_out}</td>
                      <td>
                        {item.origin_price.map((val) => {
                          return <span>{val.min}</span>;
                        })}
                      </td>
                      <td>
                        {item.origin_price.map((val) => {
                          return <span>{val.max}</span>;
                        })}
                      </td>
                      <td>
                        {item.origin_price.map((val) => {
                          return <span>{val.price}</span>;
                        })}
                      </td>

                      <td>
                        {countryList &&
                          countryList.map((data, idx) => {
                            return item.origin_price.map((val) => {
                              return val.country.map((list) => {
                                if (data._id === list.country_id) {
                                  return <span>{data.country_name}</span>;
                                }
                              });
                            });
                          })}
                      </td>
                      <td>
                        {item.origin_price.map((val) => {
                          return val.country.map((list) => {
                            return <span>{list.price}</span>;
                          });
                        })}
                      </td>

                      <td>
                        <span
                          className={
                            "badge rounded-pill font-size-12 pointer" +
                            (item.local_origin_charge_status === "ACTIVE"
                              ? " bg-success"
                              : " bg-soft-danger")
                          }
                          onClick={() => setIsModalOpen(item)}
                        >
                          {item.local_origin_charge_status}
                        </span>
                      </td>
                      <td>
                        <MdEdit
                          className="pointer"
                          onClick={() =>
                            history.push(
                              "/edit-courier-origin-charge?id=" + item._id,
                              item
                            )
                          }
                          color="#0323fe"
                          size="25px"
                        />
                      </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div> */}
          </div>

          {originCourierChargeList.length > 0 &&
            pagination.totalRecord > pagination.limit && (
              <ReactPaginate
                previousLabel={<img src="assets/images/prev.svg" height={15} alt='prev' />}
                forcePage={currentPage - 1}
                nextLabel={<img src="assets/images/next.svg" height={15} alt='next' />}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={Math.ceil(pagination.totalRecord / pagination.limit)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={(e) => onPageChangeEvent(e)}
                containerClassName={"pagination"}
                activeClassName={"active"}
              />
            )}
          <Loader isShow={loader} />
        </div>
        {Boolean(isModalOpen) && (
          <ChangeStatus
            isOpen={Boolean(isModalOpen)}
            title="Update Status"
            message={`Are you sure want to ${isModalOpen.local_origin_charge_status === "ACTIVE"
                ? "Inactive"
                : "Active"
              } status?`}
            onSubmitEvent={() => onModalSubmit()}
            handleClose={() => setIsModalOpen(false)}
          />
        )}
      </div>
    </div>
  );
};
